import { render } from "./allTemplates.vue?vue&type=template&id=ef19d786"
import script from "./allTemplates.vue?vue&type=script&lang=js"
export * from "./allTemplates.vue?vue&type=script&lang=js"

import "./allTemplates.vue?vue&type=style&index=0&id=ef19d786&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__